import React, { useState, useEffect } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";

interface Feedback {
    id: string;
    dateTime?: string;
    title?: string;
    text?: string;
    type?: string;
}

const FeedbackContent: React.FC = () => {
    const [feedbacks, setFeedbacks] = useState<Feedback[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [openForm, setOpenForm] = useState(false);
    const [type, setType] = useState("FEEDBACK");
    const [subject, setSubject] = useState("");
    const [description, setDescription] = useState("");

    useEffect(() => {
        Feedbacks();
    }, []);

    const Feedbacks = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await serviceApi.get(environment.feedback)
            if (response.status === "SUCCESS" && response.dataList) {
                setFeedbacks(response.dataList);
            } else {
                setError(response.message || "Failed to fetch feedback");
            }
        } catch (err: any) {
            setError(err.message || "Error loading feedback");
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = async () => {
        if (!subject || !description) return;

        try {

            const payload = {
                type: type,
                title: subject,
                text: description
            };

            const response = await serviceApi.post(
                environment.feedback,
                payload
            );

            if (response.status === "SUCCESS") {
                Feedbacks();
                setSubject("");
                setDescription("");
                setOpenForm(false);

            } else {
                alert(response.message || "Failed to submit feedback");
            }

        } catch (err: any) {
            alert(err.message || "Error submitting feedback");
        }
    };

    const getBg = (t: string) => {
        const x = t.toLowerCase();
        if (x === "feedback") return "var(--colorCustomDark)";
        if (x === "complaint") return "var(--colorAccentDark)";
        if (x === "academic") return "var(--colorPrimaryDark)";
        return "var(--colorPrimaryDark)";
    };

    return (
        <div className="notification-page">
            <h2 className="title-text notification-heading">Feedback</h2>
            {isLoading && (
                <div className="loading-overlay">
                    <div className="loading-overlay__content">
                        <div className="spinner spinner--lg"></div>
                        <span className="loading-text">
                            Loading feedback...
                        </span>
                    </div>
                </div>
            )}
            <div
                className="event-container"
                style={{
                    padding: "12px"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: "bold",
                        alignItems: "center"
                    }}
                >
                    <span style={{ color: "var(--colorPrimaryDark)", marginLeft: "14px", }}>
                        Write Feedback
                    </span>
                    {!openForm ? (
                        <i
                            className="fa-solid fa-plus"
                            onClick={() => setOpenForm(true)}
                            style={{
                                fontSize: "18px",
                                cursor: "pointer",
                                color: "#e0544d",
                                userSelect: "none"
                            }}
                        />
                    ) : (
                        <i
                            className="fa-solid fa-xmark"
                            onClick={() => setOpenForm(false)}
                            style={{
                                fontSize: "18px",
                                cursor: "pointer",
                                color: "#e0544d",
                                userSelect: "none"
                            }}
                        />
                    )}
                </div>
                {openForm && (
                    <div style={{ marginTop: "12px", width: "100%" }}>
                        <select
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "10px",
                                marginBottom: "10px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                                outline: "none",
                                boxSizing: "border-box"
                            }}
                        >
                            <option value="FEEDBACK">Feedback</option>
                            <option value="COMPLAINT">Complaint</option>
                            <option value="ACADEMIC">Academic</option>
                        </select>
                        <input
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            placeholder="Subject"
                            style={{
                                width: "100%",
                                padding: "10px",
                                marginBottom: "10px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                                outline: "none",
                                boxSizing: "border-box"
                            }}
                        />
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Description"
                            rows={3}
                            style={{
                                width: "100%",
                                padding: "10px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                                outline: "none",
                                resize: "none",
                                boxSizing: "border-box"
                            }}
                        />
                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                            <button
                                onClick={handleSubmit}
                                style={{
                                    background: "var(--colorPrimaryDark)",
                                    color: "#fff",
                                    border: "none",
                                    padding: "8px 16px",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                    transition: "0.3s ease"
                                }}
                                onMouseEnter={(e) =>
                                    (e.currentTarget.style.opacity = "0.85")
                                }
                                onMouseLeave={(e) =>
                                    (e.currentTarget.style.opacity = "1")
                                }
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                )}
            </div>
            {feedbacks.map((item) => (
                <div key={item.id} className="event-container">
                    {item.dateTime && (
                        <span
                            className="event-date"
                            style={{
                                color: "var(--colorPrimaryDark)",
                                fontWeight: "700"
                            }}
                        >
                            {item.dateTime}
                        </span>
                    )}
                    <div className="horizontal-divider" style={{ margin: "6px 0" }} />
                    <div className="event-item">
                        {item.title && (
                            <h4
                                className="event-title"
                                style={{
                                    color: "var(--colorAccent)",
                                    margin: "0 0 4px 0"
                                }}
                            >
                                {item.title}
                            </h4>
                        )}
                        {item.text && (
                            <p
                                className="event-description"
                                style={{
                                    margin: "0 0 6px 0"
                                }}
                            >
                                {item.text}
                            </p>
                        )}
                        {item.type && (
                            <div style={{ textAlign: "right" }}>
                                <span
                                    style={{
                                        display: "inline-block",
                                        padding: "4px 10px",
                                        borderRadius: "999px",
                                        fontSize: "var(--sz-12)",
                                        WebkitTextFillColor: "#fff",
                                        backgroundColor: getBg(item.type)
                                    }}
                                >
                                    {item.type.toUpperCase()}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FeedbackContent;